export const VP_CONSTRUCTION_OPERATIONS_REVIEW_DATA = [
    {
        id: 1,
        title: "Leadership & Accountability",
        definition: "Owns the results, standards, and health of the entire construction organization.",
        questions: [
            "Acts as the ultimate owner of construction performance at LIDA.",
            "Sets clear vision, standards, and expectations for the department.",
            "Does not tolerate recurring systemic problems.",
            "Makes timely, high-quality executive decisions.",
            "Intervenes early when performance drifts.",
            "Holds leaders accountable without politics or avoidance.",
            "Creates clarity, alignment, and confidence in the organization.",
            "Is seen as the clear leader of construction at LIDA.",
            "Leads calmly and decisively under pressure.",
            "Builds trust across leadership, teams, trades, and clients."
        ]
    },
    {
        id: 2,
        title: "Planning & Schedule Management",
        definition: "Ensures LIDA can plan, staff, and deliver work predictably at scale.",
        questions: [
            "Ensures the company has a realistic, capacity-based delivery plan.",
            "Ensures projects are properly resourced and staffed.",
            "Ensures schedules are reliable and drive execution.",
            "Prevents systemic schedule slippage across the company.",
            "Ensures long-lead items are planned and ordered early.",
            "Drives recovery plans when commitments are threatened.",
            "Provides leadership visibility into delivery risk.",
            "Rarely allows schedule or capacity surprises.",
            "Improves delivery reliability year over year.",
            "Ensures LIDA’s commitments are predictable and credible."
        ]
    },
    {
        id: 3,
        title: "Financial Management & Budget Control",
        definition: "Owns financial performance of construction operations.",
        questions: [
            "Owns the financial performance of the construction department.",
            "Ensures disciplined financial reporting.",
            "Does not allow budget or margin issues to persist.",
            "Ensures strong cost control and change management discipline.",
            "Understands and manages cashflow, not just margin.",
            "Prevents systemic margin erosion.",
            "Understands financial impact of schedule, quality, and client issues.",
            "Ensures financial risks are visible and acted on early.",
            "Builds predictability into financial outcomes.",
            "Improves financial performance year over year."
        ]
    },
    {
        id: 4,
        title: "Quality Control & Standards",
        definition: "Builds quality into the system and eliminates preventable failures.",
        questions: [
            "Sets and enforces quality standards across projects.",
            "Ensures proactive inspection standards.",
            "Reduces systemic rework across the company.",
            "Improves turnover and deficiency quality.",
            "Builds prevention systems, not heroics.",
            "Eliminates repeat quality failures.",
            "Protects durability and warranty performance.",
            "Ensures site professionalism and safety standards.",
            "Reduces project risk through standards and discipline.",
            "Raises the quality bar company-wide."
        ]
    },
    {
        id: 5,
        title: "Client / Stakeholder Experience & Communication",
        definition: "Owns the consistency, quality, and reputation of the LIDA client experience.",
        questions: [
            "Ensures consistent client experience standards across PMs.",
            "Prevents communication failures through systems.",
            "Intervenes early in client risk situations.",
            "Ensures Buildertrend and reporting standards are followed.",
            "Prevents repeat client issues and escalations.",
            "Improves client satisfaction trends year over year.",
            "Protects LIDA’s reputation in every client situation.",
            "Builds predictable, calm client experiences.",
            "Ensures problems are solved, not managed.",
            "Builds referral and brand momentum."
        ]
    },
    {
        id: 6,
        title: "Systems & Administrative Discipline",
        definition: "Builds a company that runs on systems, not memory or heroics.",
        questions: [
            "Ensures PMs follow LIDA systems and SOPs consistently.",
            "Prevents systemic admin slippage.",
            "Uses scorecards and performance points to manage.",
            "Improves system usage in practice.",
            "Eliminates workarounds and heroics.",
            "Ensures reporting is accurate and reliable.",
            "Improves meeting rhythms and management cadence.",
            "Uses data to drive decisions.",
            "Builds scalable operating systems.",
            "Ensures discipline in daily execution."
        ]
    },
    {
        id: 7,
        title: "Risk Management & Problem Prevention",
        definition: "Reduces company risk through systems and discipline.",
        questions: [
            "Proactively identifies and manages company-level risk.",
            "Ensures strong contractual, scope, and change control discipline.",
            "Prevents undocumented or informal commitments.",
            "Ensures documentation protects the company.",
            "Prevents small risks from becoming major exposures.",
            "Ensures risk is visible and managed.",
            "Reduces disputes through clarity and discipline.",
            "Builds systems that prevent recurring risk.",
            "Protects LIDA legally and reputationally.",
            "Improves company-wide risk posture year over year."
        ]
    },
    {
        id: 8,
        title: "Resource & Team Coordination",
        definition: "Builds leaders, alignment, and accountability across teams.",
        questions: [
            "Sets and enforces standards for PMs and field teams.",
            "Holds people accountable consistently and fairly.",
            "Builds a culture of ownership instead of excuses.",
            "Addresses performance issues early.",
            "Is seen as fair, firm, and consistent.",
            "Builds leaders, not just capacity.",
            "Raises standards year over year.",
            "Protects the culture from erosion.",
            "Ensures teams are properly supported and coordinated.",
            "Makes standards non-negotiable."
        ]
    },
    {
        id: 9,
        title: "Continuous Improvement & Professional Development",
        definition: "Builds a learning organization that improves every year.",
        questions: [
            "Improves systems, standards, and outcomes annually.",
            "Seeks feedback and uses it for improvement.",
            "Uses failures as learning opportunities.",
            "Builds lessons learned into systems.",
            "Invests in personal leadership growth.",
            "Develops others through coaching.",
            "Brings new tools and ideas into LIDA.",
            "Improves the organization, not just projects.",
            "Raises standards through learning.",
            "Leaves the company better each year."
        ]
    },
    {
        id: 10,
        title: "Alignment with LIDA Core Values & Culture",
        definition: "Demonstrates executive-level professionalism, maturity, and culture leadership.",
        questions: [
            "Operates with calm, disciplined judgment.",
            "Manages stress and conflict without emotional reactions.",
            "Is reliable, consistent, and prepared.",
            "Manages priorities and commitments effectively.",
            "Models executive-level behavior.",
            "Takes responsibility instead of deflecting.",
            "Represents LIDA with maturity.",
            "Builds trust through professionalism.",
            "Contributes to positive culture.",
            "Is viewed as a culture carrier at LIDA."
        ]
    }
];
